const MEDIA_ORIGIN = (process.env.REACT_APP_BASEURL || "")
  .replace(/\/api(?:\/v\d+)?\/?$/i, "")
  .replace(/\/$/, "")

export const resolveMediaUrl = value => {
  if (!value || typeof value !== "string") return null
  const url = value.trim()
  if (!url || url === "null" || url === "undefined") return null
  if (/^(https?:\/\/|blob:|data:)/i.test(url)) return url
  if (
    url.startsWith("/static") ||
    url.startsWith("/assets") ||
    url.startsWith("static/")
  ) {
    return url.startsWith("/") ? url : `/${url}`
  }
  if (!MEDIA_ORIGIN) return url.startsWith("/") ? url : `/${url}`
  return url.startsWith("/") ? `${MEDIA_ORIGIN}${url}` : `${MEDIA_ORIGIN}/${url}`
}

const isMediaObject = value =>
  Boolean(value) && typeof value === "object" && !Array.isArray(value)

const getUserMedia = user => {
  if (isMediaObject(user.profile_media)) return user.profile_media
  if (isMediaObject(user.image)) return user.image
  if (isMediaObject(user.profile_image)) return user.profile_image
  if (isMediaObject(user.avatar)) return user.avatar
  return {}
}

const firstMediaUrl = (...values) => {
  for (const value of values) {
    if (typeof value !== "string") continue
    const url = resolveMediaUrl(value)
    if (url) return url
  }
  return null
}

export const getUserAvatarUrl = user => {
  if (!user) return null
  if (typeof user === "string") return resolveMediaUrl(user)

  const media = getUserMedia(user)
  return (
    firstMediaUrl(
      media.thumbnail,
      media.thumbnail_path,
      media.image,
      media.original_path,
      user.thumbnail,
      user.image,
      user.avatar,
      user.profile_picture,
      user.profile_image,
      user.src,
      user.user_pic,
    ) || null
  )
}
